import _, { get } from "lodash";
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Icon, Image, Menu, Sidebar, Responsive, Dropdown } from "semantic-ui-react";
import { connect } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import PropTypes from "prop-types";

import "./index.scss";
import img from "../../assets/wegolook.svg";
import { isUserConsumer, isUserAdmin } from "../../utilities/auth";

const config = require("../../config");

export const NavBar = ({ items, children }) => {
  const [visible, setVisible] = useState(false);
  const [activeItem, setActiveItem] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout, loginWithRedirect, isAuthenticated } = useAuth0();

  const handleItemClick = (e, { name }) => {
    const userInfo = get(user, "https://wegolook.com/user", {});
    const userId = userInfo._id;

    setActiveItem(name);

    const goToProfile = () => {
      navigate(`/profile/${userId}`);
    };
    const goToAdmin = () => {
      navigate(`/client-admin`);
    };

    switch (name.toUpperCase().trim()) {
      case "LOG OUT":
        logout({ returnTo: config.REACT_APP_BASE_URL });
        localStorage.clear();
        break;
      case "SEARCH ORDERS":
        navigate("/search-orders");
        break;
      case "PLACE ORDER":
        navigate("/place-order");
        break;
      case "SUPPORT":
        break;
      case "EMAIL SUPPORT":
        break;
      case "(405) 795-5665":
        break;
      case "SIGN IN":
        loginWithRedirect({ appState: { returnTo: location.pathname, searchParams: location.search } });
        break;
      case "MY PROFILE":
        goToProfile(userId);
        break;
      case "ADMIN":
        goToAdmin();
        break;
      default:
        break;
    }
  };

  const logoReroute = (e, { name }) => {
    const isConsumer = isUserConsumer(user);
    setActiveItem(name);
    if (isAuthenticated) {
      if (isConsumer) {
        navigate("/instant-inspections");
      } else {
        navigate("/place-order");
      }
    } else {
      navigate("/login");
    }
  };

  const navBarMobile = (imgLogo) => {
    return (
      <Sidebar.Pushable>
        <Sidebar
          className="topMenu"
          as={Menu}
          animation="overlay"
          icon="labeled"
          inverted
          content={_.map(items, (item) => {
            return item.content === "PROFILE" ? null : (
              <Menu.Item
                active={activeItem === item.name}
                onClick={handleItemClick}
                className="menuText"
                {...item}
              />
            );
          })}
          vertical
          visible={visible}
          direction="right"
        />
        <Sidebar.Pusher dimmed={visible} onClick={handlePusher} style={{ minHeight: "100vh" }}>
          <Menu className="topMenu" fixed="top" inverted>
            <Menu.Item>{imgLogo}</Menu.Item>
            <Menu.Item onClick={handleToggle} position="right">
              <Icon name="sidebar" />
            </Menu.Item>
          </Menu>
          {navBarChildren(children)}
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    );
  };

  const navBarDesktop = (imgLogo) => {
    if (isUserAdmin(user)) {
      return (
        <Menu className="topMenu" fixed="top" inverted>
          <Menu.Item onClick={logoReroute}>{imgLogo}</Menu.Item>
          <Menu.Menu position="right">
            {_.map(items.slice(0, 2), (item) => (
              <Menu.Item
                onClick={handleItemClick}
                active={activeItem === item.name}
                className="menuText"
                {...item}
              />
            ))}
            {_.map(items, (item) => {
              if (item.content === "PROFILE") {
                return (
                  <Dropdown key={item.key} item text="PROFILE" className="menuText">
                    <Dropdown.Menu>
                      {_.map(
                        items.filter((itemOBJ) => itemOBJ.parent === "PROFILE"),
                        (i) => (
                          <Dropdown.Item
                            onClick={handleItemClick}
                            active={activeItem === item.name}
                            className="menuText"
                            {...i}
                          />
                        )
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                );
              }
              return null;
            })}
            {_.map(items, (item) => {
              if (item.content === "SUPPORT") {
                return (
                  <Dropdown key={item.key} item text="SUPPORT" className="menuText">
                    <Dropdown.Menu>
                      {_.map(
                        items.filter((itemOBJ) => itemOBJ.parent === "SUPPORT"),
                        (i) => (
                          <Dropdown.Item
                            onClick={handleItemClick}
                            active={activeItem === item.name}
                            className="menuText"
                            {...i}
                          />
                        )
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                );
              }
              return null;
            })}
          </Menu.Menu>
        </Menu>
      );
    } else if (!isUserAdmin(user) && isUserConsumer(user) && user != null) {
      return (
        <Menu className="topMenu" fixed="top" inverted>
          <Menu.Item onClick={logoReroute}>{imgLogo}</Menu.Item>
          <Menu.Menu position="right">
            {_.map(items.slice(0, 1), (item) => (
              <Menu.Item
                onClick={handleItemClick}
                active={activeItem === item.name}
                className="menuText"
                {...item}
              />
            ))}
            {_.map(items, (item) => {
              if (item.content === "LOG OUT") {
                return (
                  <Dropdown key={item.key} item text="PROFILE" className="menuText">
                    <Dropdown.Menu>
                      {_.map(
                        items.filter((itemOBJ) => itemOBJ.parent === "PROFILE" && itemOBJ.name !== "ADMIN"),
                        (i) => (
                          <Dropdown.Item
                            onClick={handleItemClick}
                            active={activeItem === item.name}
                            className="menuText"
                            {...i}
                          />
                        )
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                );
              }
              return null;
            })}
            {_.map(items, (item) => {
              if (item.content === "SUPPORT") {
                return (
                  <Dropdown key={item.key} item text="SUPPORT" className="menuText">
                    <Dropdown.Menu>
                      {_.map(
                        items.filter((itemOBJ) => itemOBJ.parent === "SUPPORT"),
                        (i) => (
                          <Dropdown.Item
                            onClick={handleItemClick}
                            active={activeItem === item.name}
                            className="menuText"
                            {...i}
                          />
                        )
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                );
              }
              return null;
            })}
          </Menu.Menu>
        </Menu>
      );
    } else if (!isUserAdmin(user) && user != null) {
      return (
        <Menu className="topMenu" fixed="top" inverted>
          <Menu.Item onClick={logoReroute}>{imgLogo}</Menu.Item>
          <Menu.Menu position="right">
            {_.map(items.slice(0, 2), (item) => (
              <Menu.Item
                onClick={handleItemClick}
                active={activeItem === item.name}
                className="menuText"
                {...item}
              />
            ))}
            {_.map(items, (item) => {
              if (item.content === "PROFILE") {
                return (
                  <Dropdown key={item.key} item text="PROFILE" className="menuText">
                    <Dropdown.Menu>
                      {_.map(
                        items.filter((itemOBJ) => itemOBJ.parent === "PROFILE" && itemOBJ.name !== "ADMIN"),
                        (i) => (
                          <Dropdown.Item
                            onClick={handleItemClick}
                            active={activeItem === item.name}
                            className="menuText"
                            {...i}
                          />
                        )
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                );
              }
              return null;
            })}
            {_.map(items, (item) => {
              if (item.content === "SUPPORT") {
                return (
                  <Dropdown key={item.key} item text="SUPPORT" className="menuText">
                    <Dropdown.Menu>
                      {_.map(
                        items.filter((itemOBJ) => itemOBJ.parent === "SUPPORT"),
                        (i) => (
                          <Dropdown.Item
                            onClick={handleItemClick}
                            active={activeItem === item.name}
                            className="menuText"
                            {...i}
                          />
                        )
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                );
              }
              return null;
            })}
          </Menu.Menu>
        </Menu>
      );
    }
    return (
      <Menu className="topMenu" fixed="top" inverted>
        <Menu.Item onClick={logoReroute}>{imgLogo}</Menu.Item>
        <Menu.Menu position="right">
          {_.map(items, (item) => (
            <Menu.Item
              onClick={handleItemClick}
              active={activeItem === item.name}
              className="menuText"
              {...item}
            />
          ))}
        </Menu.Menu>
      </Menu>
    );
  };

  const navBarChildren = (childrenContent) => <div style={{ paddingTop: "5em" }}>{childrenContent}</div>;

  const handlePusher = () => {
    if (visible) setVisible(false);
  };

  const handleToggle = () => setVisible(!visible);

  const imgLogo = (
    <>
      <Image
        src={img}
        style={{
          width: 120,
          padding: 0,
          height: 50,
        }}
      />
    </>
  );

  return (
    <div className="workspace-navbar">
      <Responsive {...Responsive.onlyMobile}>{navBarMobile(imgLogo)}</Responsive>
      <Responsive minWidth={Responsive.onlyTablet.minWidth}>
        {navBarDesktop(imgLogo)}
        {navBarChildren(children)}
      </Responsive>
    </div>
  );
};

NavBar.propTypes = {
  items: PropTypes.array,
};

export default connect()(NavBar);
